import React, { useState, useEffect, useRef } from "react";
import { data, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from '@app/store';
import { fetchAffiliates } from "../affiliate/AffiliateSlice";
import { fetchUserProfile } from "../auth/authSlice";
import {  ClientOutputDTO } from './types';
import { AffiliateOutputDTO } from "../affiliate/types";
import { DataForm } from '@components/ui';
import { Field } from '@components/ui/DataForm';
import { FormSkeleton } from '@components/ui/FormSkeleton';
import { ApiError } from '@/types/api';
import { useNotification } from '@hooks/useNotification';
import { Box, Typography, Alert } from "@mui/material";
import { useAuth } from '@hooks/useAuth';
import { clientActions, createClient, fetchClientById, updateClient } from "./ClientSlice";
import { ClientMapper } from "./ClientMapper";

async function readFileAsDataURL(file:any) {
    let result_base64 = await new Promise((resolve) => {
        let fileReader = new FileReader();
        fileReader.onload = (e) => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
    });

    console.log(result_base64); // aGV5IHRoZXJl...

    return result_base64;
}

const ClientsForm: React.FC = (props:any) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const data = useSelector(
    (state: RootState) => state.client
  );
  let currentItem = data?.currentItem?.data;
  let loading = data.loading;

  console.log(currentItem)
  const { items: affiliates, loading: affiliatesLoading } = useSelector(
    (state: RootState) => state.affiliate
  );
  
  // Get current user info from auth state
  const { user, isAuthenticated } = useAuth();
  const [formData, setFormData] = useState<Partial<any>>({});
  const [formError, setFormError] = useState<ApiError | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const notification = useNotification();

  const isLoadingRef = useRef(false);
  const initialLoadDoneRef = useRef(false);
  const submitAttemptRef = useRef(false);
  const ignoreAreaChange = useRef(true);
  const ignoreRoleChange = useRef(true);

  const ignoreSectorChange = useRef(true);

  console.log('formdata',formData)
  // Make sure we have the current user data
  useEffect(() => {
    if (isAuthenticated && !user) {
      console.log("🔄 Fetching current user profile");
      dispatch(fetchUserProfile());
    }
  }, [dispatch, isAuthenticated, user]);

  // Debug output for current user
  useEffect(() => {
    console.log("🧪 Current authenticated user:", user);
  }, [user]);

  // User role-based access control
  const currentUserRole = user?.role ;
  
  // Redirect lawyer users away from this form
  useEffect(() => {
   
  }, [currentUserRole, navigate, notification]);

  useEffect(() => {
    const loadData = async () => {
      if (isLoadingRef.current || initialLoadDoneRef.current) {
        return;
      }

      try {
        console.log("📡 Iniciando carregamento do Usuário:", id);
        isLoadingRef.current = true;

        // Load affiliates
        console.log("📡 UserForm - Carregando Afiliados");
        await dispatch(fetchAffiliates({}));

        if (id) {
          console.log("📡 UserForm - Carregando Usuário:", id);
          const resultAction = await dispatch(fetchClientById(id));

          if (fetchClientById.fulfilled.match(resultAction)) {
            console.log("✅ Usuário carregado com sucesso");
          } else {
            throw new Error("Erro ao carregar dados");
          }
        }
      } catch (error) {
        console.error("❌ Erro ao carregar Usuário:", error);
        notification.showError("Erro ao carregar dados");
        setFormError({
          message: "Erro ao carregar dados",
          code: "LOAD_ERROR",
          statusCode: 500,
        });
      } finally {
        isLoadingRef.current = false;
        initialLoadDoneRef.current = true;
        setIsInitialLoad(false);
      }
    };

    loadData();

    return () => {
      console.log("🧹 Limpando estado do formulário");
      dispatch(clientActions.clearCurrentItem());
    };
  }, []);
  

  useEffect(() => {
    if (currentItem) {
      console.log("📝 User - Atualizando dados do formulário:", currentItem);
      ignoreSectorChange.current=true;
      ignoreAreaChange.current=true;
      ignoreRoleChange.current=true;

      let role = null;
    //   if(currentItem.enterpriseId && affiliates.length>0 && currentItem.role){
    //   role = affiliates.filter((item)=>item._id==currentItem.enterpriseId)[0]?.roles?.filter((item:any)=>item._id==currentItem.role)[0];
    //   console.log('role update',role)
    // }
      console.log('vai atualizar');
      setFormData({
        name: currentItem.name,
        email: currentItem.email,
        // status: currentItem.status==UserStatus.ACTIVE?false:true,
        city: currentItem.places?.length>0? currentItem.places[0]?.cityName: '',
        street: currentItem.places?.length>0? currentItem.places[0]?.street: '',
        number: currentItem.places?.length>0? currentItem.places[0]?.number: '',
        neighborhood: currentItem.places?.length>0? currentItem.places[0]?.neighborhood: '',
        state: currentItem.places?.length>0? currentItem.places[0]?.stateCode: '',
        postal: currentItem.places?.length>0? currentItem.places[0]?.zip_code: '',
        cpf: currentItem.cpf ?? '',
        whatsapp: currentItem.whatsapp ?? '',

        image: currentItem.im ?? '',



        // enterpriseId: currentItem.enterpriseId,
      });
    }
  }, [currentItem]);

 

  const [fields,setFields] = useState<any>([
   
    {
      name: "image",
      label: "Imagem",
      type: "image",
      show:['name'],
      required: true,
      col:'48%',
      validationError: formError?.validationErrors?.name?.message,
    },
    
     {
      name:'section1',
      type:'section',
      label:'Informações Gerais'
    },
     {
      name:'separator',
      type:'separator',
      label:'Informações Gerais'
    },
    {
      name: "name",
      label: "Nome",
      type: "text",
      required: true,
      col:'100%',
      validationError: formError?.validationErrors?.name?.message,
    },
    {
      name: "email",
      label: "Email",
      type: "text",
      required: true,
      col:'48%',
      validationError: formError?.validationErrors?.email?.message,
    },
   
    {
      name: "cpf",
      label: "CPF",
      type: "text",
      required: true,
      col:'48%',
      validationError: formError?.validationErrors?.cpf?.message,
    },
    
     
     {
      name: "whatsapp",
      label: "Whatsapp",
      type: "text",
      col:'100%',
      required: true,
      validationError: formError?.validationErrors?.whatsapp?.message,
    },
   
    {
      name:'section',
      type:'section',

      label:'Endereço'
    },
     {
      name:'separator1',
      type:'separator',
      label:'Endereço'
    },
    {
      name: "postal",
      label: "CEP",
      type: "text",
      required: true,
      col:'100%',
      validationError: formError?.validationErrors?.postal?.message,
    },
    {
      name: "street",
      label: "Rua",
      type: "text",
      required: true,
      col:'48%',
      validationError: formError?.validationErrors?.street?.message,
    },
    {
      name: "number",
      label: "Número",
      type: "text",
      required: false,
      col:'48%',
      validationError: formError?.validationErrors?.number?.message,
    },

    {
      name: "neighborhood",
      label: "Bairro",
      type: "text",
      required: true,
      col:'100%',
      validationError: formError?.validationErrors?.neighborhood?.message,
    },
    {
      name: "city",
      label: "Cidade",
      type: "text",
      required: true,
      col:'48%',
      validationError: formError?.validationErrors?.city?.message,
    },
    {
      name: "state",
      label: "Estado (Sigla)",
      type: "text",
      required: true,
      col:'48%',
      validationError: formError?.validationErrors?.state?.message,
    },
   
  ]);

  const handleSubmit = async (data2: Partial<ClientOutputDTO>) => {
    if (submitAttemptRef.current) {
      notification.showWarning("Submissão em andamento, aguarde...");
      return;
    }
    let data:any={...data2}

    try {
      submitAttemptRef.current = true;
      setIsSubmitting(true);
      setFormError(null);

      if(data?.image instanceof File){
        data.image = await readFileAsDataURL(data.image);
      }
      else{
        data.im=data.image;
        delete data.image;
      }

      // If password is empty in edit mode, remove it from the payload
      

      // if(data.status==true) data.status=UserStatus.INACTIVE;
      // else data.status=UserStatus.ACTIVE;

      // If the user is a Manager trying to create an Admin, prevent it
     

      // If the user is a Manager, keep the existing enterpriseId or set the current user's enterpriseId
     
      
      data.enterpriseId = user?.enterpriseId;
      let mappedData = ClientMapper.toDTO(data);
      mappedData.places=[{
         zip_code: data.postal,
  street: data.street,
  number: data.number,
  complement: '-',
  neighborhood: data.neighborhood,
  cityName: data.city,
  stateCode: data.state,
      }]
      console.log("📤 Enviando dados:", mappedData);

      const resultAction = id
        ? await dispatch(updateClient({ id, data: mappedData }))
        : await dispatch(createClient(mappedData));

      if (
        updateClient.rejected.match(resultAction) ||
        createClient.rejected.match(resultAction)
      ) {
        const error = resultAction.payload as ApiError;
        console.log(error)
        setFormError(error);
        // setFields(fields.map((item:any)=>{
        //   let data :any=error;
        //   data = data?.validationErrors[item.name]
        //   item.validationError = data?.message ?? ''
        //   return item;
        // }))
        notification.showError(error.message || "Erro ao salvar dados");
        return;
      }

      notification.showSuccess("Dados salvos com sucesso!");
      if(props.onClose){
        props.onClose();
      }
      else{
        navigate("/clients");
      }
    } catch (error) {
      console.error("❌ UserForm - Erro inesperado:", error);
      notification.showError("Erro inesperado ao salvar os dados");
      setFormError({
        code: "UNKNOWN_ERROR",
        message: "Erro inesperado ao salvar os dados",
        statusCode: 500,
      });
    } finally {
      setIsSubmitting(false);
      submitAttemptRef.current = false;
    }
  };

  // Return nothing if user is a lawyer (will be redirected)

  if (isInitialLoad && (loading || affiliatesLoading)) {
    return <FormSkeleton fields={6} />;
  }

  return (
    <>
    {/* <Box sx={{ p: 3 }}> */}
     {/*  <Typography variant="h5" gutterBottom>
        {id ? "Editar Usuário" : "Novo Usuário"}
      </Typography>
       */}
      {/* // {currentUserRole === UserRole.MANAGER && ( */}
      {/* //   <Alert severity="info" sx={{ mb: 3 }}>
      //     Como gerente, você não pode criar usuários administradores nem alterar a empresa vinculada ao usuário.
      //   </Alert>
      // )} */}
      
      <DataForm
        data={formData}
        setFormDataParent={setFormData}
        fields={fields}
        onClose={props.onClose}
        isEdit={id!=undefined}
        onSubmit={handleSubmit}
        basePath="clients"
        title={id ? "Editar Cliente" : "Novo Cliente"}
        error={formError}
        onClearError={() => setFormError(null)}
        disabled={isSubmitting}
      />
      {/* </Box> */}
    {/* // 
    // </div> */}
    </>

  );
};

export default ClientsForm;
